<template>
  <div class="event-toast">
    <div class="event-header">
      <strong>{{ eventTitle }}</strong>
      <b-button
        size="sm"
        variant="link"
        class="ml-2 p-0"
        @click="showDetails = !showDetails"
      >
        <b-icon-chevron-down v-if="!showDetails"></b-icon-chevron-down>
        <b-icon-chevron-up v-else></b-icon-chevron-up>
      </b-button>
    </div>
    <div v-if="showDetails" class="event-details mt-2">
      <small class="text-muted">
        <b-form-group label="Event Name:" label-class="font-weight-bold text-dark">
          <code class="event-code">{{ eventData.event }}</code>
        </b-form-group>
        <div v-if="eventData.ecommerce" class="mt-2">
          <b-form-group label="Ecommerce Data:" label-class="font-weight-bold text-dark">
            <code class="event-code">{{ JSON.stringify(eventData.ecommerce, null, 2) }}</code>
          </b-form-group>
        </div>
        <div v-if="customData && Object.keys(customData).length" class="mt-2">
          <b-form-group label="Custom Data:" label-class="font-weight-bold text-dark">
            <code class="event-code">{{ JSON.stringify(customData, null, 2) }}</code>
          </b-form-group>
        </div>
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventToast',
  props: {
    eventTitle: {
      type: String,
      required: true
    },
    eventData: {
      type: Object,
      required: true
    },
    customData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showDetails: false
    };
  }
};
</script>

<style scoped>
.event-toast {
  background: white;
  border-radius: 4px;
  padding: 12px;
}

.event-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.event-details {
  border-top: 1px solid #e9ecef;
  padding-top: 10px;
  max-height: 400px;
  overflow-y: auto;
}

.event-code {
  display: block;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 8px;
  font-size: 11px;
  line-height: 1.4;
  color: #333;
  white-space: pre-wrap;
  word-break: break-all;
  max-width: 500px;
}
</style>
